class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupSubTriggers();
  }

  setupSubTriggers() {
    this._subClearTimer = null;

    this.querySelectorAll('.mega-menu__sub-trigger[data-id]').forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        clearTimeout(this._subClearTimer);
        this.activateSubList(trigger);
      });
      trigger.addEventListener('mouseleave', () => {
        const content = trigger.closest('.mega-menu__content') || trigger.closest('.mega-menu__inner');
        if (content) {
          this._subClearTimer = setTimeout(() => this.clearSubLists(content), 80);
        }
      });
      trigger.addEventListener('click', () => {
        const href = trigger.dataset.href;
        if (href) window.location.href = href;
      });
    });

    this.querySelectorAll('.mega-menu__sub-list[data-id]').forEach((subList) => {
      subList.addEventListener('mouseenter', () => clearTimeout(this._subClearTimer));
      subList.addEventListener('mouseleave', () => {
        const content = subList.closest('.mega-menu__content') || subList.closest('.mega-menu__inner');
        if (content) {
          this._subClearTimer = setTimeout(() => this.clearSubLists(content), 80);
        }
      });
    });
  }

  activateSubList(trigger) {
    const id = trigger.dataset.id;
    const content = trigger.closest('.mega-menu__content') || trigger.closest('.mega-menu__inner');
    if (!content) return;

    this.clearSubLists(content);

    const target = content.querySelector(`.mega-menu__sub-list[data-id="${id}"]`);
    if (target) target.classList.add('is-active');
    trigger.classList.add('is-active');
  }

  clearSubLists(content) {
    content.querySelectorAll('.mega-menu__sub-list[data-id]').forEach((list) => {
      list.classList.remove('is-active');
    });
    content.querySelectorAll('.mega-menu__sub-trigger[data-id]').forEach((t) => {
      t.classList.remove('is-active');
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

  }
}

customElements.define('header-menu', HeaderMenu);
